import { useEffect, useRef } from 'react';

const ElementEventListener = (
  selectorValue,
  eventType,
  data,
  retryDelay = 2000,
) => {
  const handler = () => {
    window.tagular?.('beam', {
      '@type': 'core.conversions.ConversionTracked.v2',
      correlation: {
        id: data.tglrCorrelationId,
      },
      metadata: {
        category: 'Enrollment',
        action: 'Upgraded',
        timestamp: new Date().toISOString(),
        productList: [{
          brand: data.org,
          variant: 'courses',
          name: data.courseName,
        }],
      },
    });
  };
  const handlerRef = useRef(handler);
  const retryTimeoutRef = useRef(null);
  const options = {};

  // Update handler ref if it changes
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const element = document.querySelector(selectorValue);

    const wrappedHandler = (e) => {
      handlerRef.current(e);
    };

    if (element) {
      element.addEventListener(eventType, wrappedHandler, options);
    } else {
      // Retry mechanism to check for element
      retryTimeoutRef.current = setTimeout(() => {
        const retryElement = document.querySelector(selectorValue);
        if (retryElement) {
          retryElement.addEventListener(eventType, wrappedHandler, options);
        }
      }, retryDelay);
    }

    return () => {
      clearTimeout(retryTimeoutRef.current);
      if (element) {
        element.removeEventListener(eventType, wrappedHandler, options);
      }
    };
  }, [selectorValue, eventType, options, retryDelay]);

  return null;
};

export default ElementEventListener;
